export default __webpack_public_path__ + "static/DSC_0174-702b342eddaf961ddf99b2ab368a58eb.jpg";